import Markdown from 'components/commercetools-ui/content/markdown';

const MarkdownTastic = ({ data }) => {
  return <Markdown text={data.markdown} breakLines={data.breakBoldText} />;
};

export default MarkdownTastic;
